import React, { useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons";

const coursesData = [
    {
      course: "CMPT 307",
      courseName: "Data Structures and Algorithms",
      courseDFWRate: "15%",
      combinedDFWRate: "18%",
      diff: "3%",
      students: 13
    },
    {
      course: "CMPT 354",
      courseName: "Database Systems I",
      courseDFWRate: "13%",
      combinedDFWRate: "10%",
      diff: "-3%",
      students: 17
    },
    {
      course: "CMPT 363",
      courseName: "User Interface Design",
      courseDFWRate: "14%",
      combinedDFWRate: "22%",
      diff: "8%",
      students: 22
    },
    {
      course: "CMPT 405",
      courseName: "Design and Analysis of Algorithms",
      courseDFWRate: "15%",
      combinedDFWRate: "16%",
      diff: "1%",
      students: 19
    },
    {
      course: "CMPT 454",
      courseName: "Database Systems II",
      courseDFWRate: "14%",
      combinedDFWRate: "16%",
      diff: "2%",
      students: 14
    },
    {
      course: "CMPT 459",
      courseName: "Data Mining",
      courseDFWRate: "14%",
      combinedDFWRate: "10%",
      diff: "-4%",
      students: 29
    },
    {
      course: "CMPT 464",
      courseName: "Introduction to Artificial Intelligence",
      courseDFWRate: "16%",
      combinedDFWRate: "20%",
      diff: "4%",
      students: 31
    },
    {
      course: "CMPT 470",
      courseName: "Web-Based Information Systems",
      courseDFWRate: "16%",
      combinedDFWRate: "13%",
      diff: "-3%",
      students: 18
    },
    {
      course: "CMPT 475",
      courseName: "Computational Vision",
      courseDFWRate: "13%",
      combinedDFWRate: "19%",
      diff: "6%",
      students: 23
    },
    {
      course: "CMPT 479",
      courseName: "Robotics",
      courseDFWRate: "12%",
      combinedDFWRate: "11%",
      diff: "-1%",
      students: 27
    },
    {
      course: "CMPT 487",
      courseName: "Deep Learning",
      courseDFWRate: "15%",
      combinedDFWRate: "11%",
      diff: "-4%",
      students: 16
    },
    {
      course: "MACM 316",
      courseName: "Numerical Analysis I",
      courseDFWRate: "12%",
      combinedDFWRate: "19%",
      diff: "7%",
      students: 12
    },
    {
      course: "MATH 310",
      courseName: "Introduction to Ordinary Differential Equations",
      courseDFWRate: "12%",
      combinedDFWRate: "11%",
      diff: "-1%",
      students: 21
    },
    {
      course: "MATH 320",
      courseName: "Real Analysis I",
      courseDFWRate: "14%",
      combinedDFWRate: "15%",
      diff: "1%",
      students: 20
    },
    {
      course: "MATH 340",
      courseName: "Group Theory",
      courseDFWRate: "15%",
      combinedDFWRate: "17%",
      diff: "2%",
      students: 26
    },
    {
      course: "MATH 345",
      courseName: "Number Theory",
      courseDFWRate: "13%",
      combinedDFWRate: "16%",
      diff: "3%",
      students: 15
    },
    {
      course: "MATH 350",
      courseName: "Geometry",
      courseDFWRate: "14%",
      combinedDFWRate: "18%",
      diff: "4%",
      students: 24
    },
    {
      course: "MATH 370",
      courseName: "Applied Linear Algebra",
      courseDFWRate: "13%",
      combinedDFWRate: "10%",
      diff: "-3%",
      students: 29
    },
    {
      course: "MATH 380",
      courseName: "Complex Variables",
      courseDFWRate: "15%",
      combinedDFWRate: "21%",
      diff: "6%",
      students: 33
    },
    {
      course: "MATH 390",
      courseName: "Partial Differential Equations",
      courseDFWRate: "16%",
      combinedDFWRate: "24%",
      diff: "8%",
      students: 17
    },
    {
      course: "STAT 330",
      courseName: "Introduction to Mathematical Statistics",
      courseDFWRate: "14%",
      combinedDFWRate: "10%",
      diff: "-4%",
      students: 14
    },
    {
      course: "STAT 350",
      courseName: "Linear Models in Applied Statistics",
      courseDFWRate: "12%",
      combinedDFWRate: "19%",
      diff: "7%",
      students: 18
    },
    {
      course: "STAT 380",
      courseName: "Stochastic Processes",
      courseDFWRate: "12%",
      combinedDFWRate: "11%",
      diff: "-1%",
      students: 22
    },
    {
      course: "STAT 410",
      courseName: "Sample Surveys",
      courseDFWRate: "15%",
      combinedDFWRate: "16%",
      diff: "1%",
      students: 19
    },
    {
      course: "STAT 430",
      courseName: "Experimental Design",
      courseDFWRate: "15%",
      combinedDFWRate: "23%",
      diff: "8%",
      students: 16
    },
    {
      course: "STAT 440",
      courseName: "Learning from Big Data",
      courseDFWRate: "16%",
      combinedDFWRate: "20%",
      diff: "4%",
      students: 20
    },
    {
      course: "STAT 452",
      courseName: "Statistical Learning and Prediction",
      courseDFWRate: "15%",
      combinedDFWRate: "18%",
      diff: "3%",
      students: 23
    },
    {
      course: "STAT 460",
      courseName: "Bayesian Statistics",
      courseDFWRate: "13%",
      combinedDFWRate: "20%",
      diff: "7%",
      students: 15
    },
    {
      course: "STAT 475",
      courseName: "Applied Discrete Data Analysis",
      courseDFWRate: "14%",
      combinedDFWRate: "20%",
      diff: "6%",
      students: 28
    },
    {
      course: "STAT 485",
      courseName: "Applied Time Series Analysis",
      courseDFWRate: "14%",
      combinedDFWRate: "16%",
      diff: "2%",
      students: 17
    }
  ];
    
  

const HighFailCombinations = ({ courseNumber }) => {
  // State for sorting: key and direction
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  // Toggle sort order on header click
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Sort data based on the sortConfig
  const sortedData = useMemo(() => {
    const sortableData = [...coursesData];
    if (sortConfig.key !== null) {
      sortableData.sort((a, b) => {
        let aValue, bValue;
        if (sortConfig.key === "courseName") {
          aValue = (a.courseName).toLowerCase();
          bValue = (b.courseName).toLowerCase();
        } else if (
          sortConfig.key === "courseDFWRate" ||
          sortConfig.key === "combinedDFWRate" ||
          sortConfig.key === "diff"
        ) {
          aValue = parseFloat(a[sortConfig.key]);
          bValue = parseFloat(b[sortConfig.key]);
        } else {
          aValue = a[sortConfig.key];
          bValue = b[sortConfig.key];
          if (typeof aValue === "string") aValue = aValue.toLowerCase();
          if (typeof bValue === "string") bValue = bValue.toLowerCase();
        }
        if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortableData;
  }, [sortConfig]);

  // Helper function to compute the background color for diff values.
  // Negative: from green (-25%) to slight yellow at 0%.
  // Positive: from slight yellow at 0% to red (25%).
  const getGradientColor = (diffStr) => {
    let diffValue = parseFloat(diffStr);
    // Clamp diffValue between -25 and 25
    if (diffValue < -20) diffValue = -20;
    if (diffValue > 20) diffValue = 20;
    
    // Define our key colors:
    // Green at -25%: rgb(0,255,0)
    // Slight yellow at 0%: rgb(255,255,224)
    // Red at 25%: rgb(255,0,0)
    
    if (diffValue < 0) {
      // Negative diff: interpolate between green and slight yellow.
      // factor = 0 at -25, factor = 1 at 0.
      const factor = (diffValue + 20) / 20;
      const red = Math.round(0 + factor * (255 - 0));
      const green = 255;
      const blue = Math.round(0 + factor * (224 - 0));
      return `rgb(${red}, ${green}, ${blue})`;
    } else {
      // Positive diff: interpolate between slight yellow and red.
      // factor = 0 at 0, factor = 1 at 25.
      const factor = diffValue / 20;
      const red = 255;
      const green = Math.round(255 - factor * (255 - 0));
      const blue = Math.round(224 - factor * (224 - 0));
      return `rgb(${red}, ${green}, ${blue})`;
    }
  };

  return (
    <div className="p-4 bg-gray-50 shadow-md border rounded-lg">
      {/* Container for vertical scrolling with max height 75vh */}
      <div className="relative overflow-x-auto overflow-y-auto" style={{ maxHeight: "75vh" }}>
        <table className="table-fixed w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-100 sticky top-0 z-10">
            <tr>
              <th
                className="pl-4 pr-2 pt-3 pb-1 cursor-pointer"
                style={{ width: "17%" }}
                onClick={() => handleSort("course")}
              >
                Course ID{" "}
                <FontAwesomeIcon icon={faSort} className="ml-1" style={{ fontSize: "10px" }} />
              </th>
              <th
                className="px-2 pt-3 pb-1 cursor-pointer"
                style={{ width: "30%" }}
                onClick={() => handleSort("courseName")}
              >
                Course Name{" "}
                <FontAwesomeIcon icon={faSort} className="ml-1" style={{ fontSize: "10px" }} />
              </th>
              <th
                className="px-2 pt-3 pb-1 cursor-pointer text-center"
                style={{ width: "11%" }}
                onClick={() => handleSort("courseDFWRate")}
              >
                DFW Rate{" "}
                <FontAwesomeIcon icon={faSort} className="ml-1" style={{ fontSize: "10px" }} />
              </th>
              <th
                className="relative px-2 pt-1.5 pb-1.5 cursor-pointer text-center"
                style={{ width: "17%" }}
                onClick={() => handleSort("combinedDFWRate")}
              >
                <div className="flex items-center justify-center gap-2">
                  <div className="text-center">
                    <div>DFW Rate Taken</div>
                    <div>with {courseNumber}</div>
                  </div>
                  <FontAwesomeIcon icon={faSort} style={{ fontSize: "10px" }} />
                </div>
              </th>
              <th
                className="relative px-2 pt-1.5 pb-1.5 cursor-pointer text-center"
                style={{ width: "13%" }}
                onClick={() => handleSort("diff")}
              >
                <div className="flex items-center justify-center gap-2">
                  <div className="text-center">
                    <div>DFW Rate</div>
                    <div>Difference</div>
                  </div>
                  <FontAwesomeIcon icon={faSort} style={{ fontSize: "10px" }} />
                </div>
              </th>
              <th
                className="px-2 pt-3 pb-1 cursor-pointer text-center"
                style={{ width: "11%" }}
                onClick={() => handleSort("students")}
              >
                Students{" "}
                <FontAwesomeIcon icon={faSort} className="ml-1" style={{ fontSize: "10px" }} />
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((item, idx) => (
              <tr key={idx} className="bg-white border-b hover:bg-gray-50">
                <td
                  className="pl-4 pr-2 pt-2 pb-2 whitespace-nowrap text-sm text-gray-900"
                  style={{ width: "25%" }}
                >
                  {item.course}
                </td>
                <td
                  className="px-2 pt-2 pb-2 whitespace-nowrap text-sm text-gray-900"
                  style={{ width: "35%" }}
                >
                  {item.courseName}
                </td>
                <td
                  className="px-2 pt-2 pb-2 whitespace-nowrap text-sm text-gray-900 text-center"
                  style={{ width: "10%" }}
                >
                  {item.courseDFWRate}
                </td>
                <td
                  className="px-2 pt-2 pb-2 whitespace-nowrap text-sm text-gray-900 text-center"
                  style={{ width: "10%" }}
                >
                  {item.combinedDFWRate}
                </td>
                <td
                  className="px-2 pt-2 pb-2 whitespace-nowrap text-sm text-gray-900 text-center"
                  style={{
                    width: "10%",
                    backgroundColor: getGradientColor(item.diff)
                  }}
                >
                  {item.diff}
                </td>
                <td
                  className="px-2 pt-2 pb-2 whitespace-nowrap text-sm text-gray-900 text-center"
                  style={{ width: "10%" }}
                >
                  {item.students}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HighFailCombinations;
